import { FaPhoneAlt } from 'react-icons/fa';
import { CRUISE_PHONE_DISPLAY, CRUISE_PHONE_TEL } from '../../constants/contact';
import '../explore/ExploreCta.css';

export default function CruiseCta({
  variant = 'banner',
  title,
  subtitle,
  className = '',
}) {
  const rootClass = ['explore-cta', `explore-cta--${variant}`, className].filter(Boolean).join(' ');

  return (
    <div className={rootClass} role="region" aria-label="Contact options">
      {(title || subtitle) && (
        <div className="explore-cta__copy">
          {title && <p className="explore-cta__title">{title}</p>}
          {subtitle && <p className="explore-cta__subtitle">{subtitle}</p>}
        </div>
      )}
      <div className="explore-cta__actions">
        <a href={`tel:${CRUISE_PHONE_TEL}`} className="explore-cta__btn explore-cta__btn--call">
          <FaPhoneAlt aria-hidden />
          <span>
            <small>Call 24/7</small>
            <strong>{CRUISE_PHONE_DISPLAY}</strong>
          </span>
        </a>
      </div>
    </div>
  );
}
